import React, {useEffect, useState} from 'react';
import * as XLSX from 'xlsx/xlsx.mjs';

import Topbar from './components/micro/Topbar';
import Header from './components/micro/Header';
import InfoTable from './../../common/components/InfoTable';

import {ToLL, colorName, latlng} from '../../helpers';

import { vfnColor } from '../../common/functions/vfn';
import { Tr } from './components/micro/Tr';
import { Next } from './components/micro/Next';
import { Page } from './components/micro/Page';
import { List } from './components/micro/List';
import { Table } from './components/micro/Table';
import { Mover } from './components/micro/Mover';
import { Wrapper } from './components/micro/Wrapper';
import { DatiList } from './components/micro/DatiList';
import { Macrodivisione } from './components/micro/Macrodivisione';
import { Tab } from './components/micro/Tab';
import { Tabs } from './components/micro/Tabs';
import { SondaggiPage } from './pages/SondaggiPage';
import { CampionePage } from './pages/CampionePage';
import { PiezometroPage } from './pages/PiezometroPage';

const downloadLv4 = (campione, dati) => {
	var workbook = XLSX.utils.book_new();
	let values = [];
	dati.forEach(dato => {
		values.push([
			dato.has_terreno ? "Terreno"  : "Eluato",
			dato.descGruppo,
			dato.parametro,
			dato.valore,
			dato.vfn,
			dato.udm,
			dato.has_terreno ? dato.colA + " - " + dato.colB : dato.colA,
			(dato.coloreDato === 3 || dato.coloreDato === "3") ? "Rosso" :
			(dato.coloreDato === 2 || dato.coloreDato === "2") ? "Giallo" :
			(dato.coloreDato === 1 || dato.coloreDato === "1") ? "Verde" : "Bianco"
		])
	})

	var worksheet = XLSX.utils.aoa_to_sheet([
		["Tipologia", "Gruppo", "Parametro", "Valore", "VFN", "UdM", "Soglie", "Colore"],
		...values
	]);
	  XLSX.utils.book_append_sheet(workbook, worksheet, "Worksheet");

		const today = new Date();
		const yyyy = today.getFullYear();
		let mm = today.getMonth() + 1;
		let dd = today.getDate();
		let h = today.getHours();
		let i = today.getMinutes();
		let s = today.getSeconds();

		if (dd < 10) dd = '0' + dd;
		if (mm < 10) mm = '0' + mm;

		const formattedToday = dd + '-' + mm + '-' + yyyy + '_' + h + '-' + i + '-' + s;

		XLSX.writeFile(workbook, "cesi_export_campione_"+campione.codice_cesi+"_"+formattedToday+".xlsx");
  }

const Navigator = ({
	layout,
	listLv1,
	listLv2,
	listLv3,
	listLv4,
	listLv5,
	lv0,
	lv1,
	setLv1,
	hoverLv1,
	setHoverLv1,
	lv2,
	setLv2,
	hoverLv2,
	setHoverLv2,
	lv3,
	setLv3,
	hoverLv3,
	setHoverLv3,
	lv4,
	setLv4,
	hoverLv4,
	setHoverLv4,
	listDocs
}) => {

	const variableFormat = str => {
		const num = parseFloat(str)
		if (num < 1 && num > 0) {
			// prevent exponential format by parsing it and straightening it up
			const {a,b,z} = num.toExponential().match(/(?<a>\d+)?\.?(?<b>\d+)?e-(?<z>\d+)/).groups
			return '0.' + [...Array(parseInt(z) - 1).keys()].map(k => '0').join('') + (a ?? '') + (b ?? '')
		}
		return num.toString()
	}

  const [showEluato, setShowEluato] = useState(false);
  // const [activeSite, setActiveSite] = useState(null);

  // useEffect(() => {
  //   AnalyticsService.init();
  // }, []);

  useEffect(() => {
    setShowEluato(false);
  }, [lv4]);

  return (
    <Wrapper>
		<Mover current={
			lv4 ? 4 :
			lv3 ? 3 :
			lv2 ? 2 :
			lv1 ? 1 : 0
		}>
			<Page>
				<Topbar>Macro Lotti</Topbar>
				<Header
					lv0={lv0 ? lv0.nome : null}
				/>
				<List>
					<Table>
						<thead>
							<tr>
								<th>Nome</th>
								<th>Descrizione</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{listLv1 ? listLv1.map((macrolotto, i) =>
								<Tr
									key={i}
									onMouseEnter={() => setHoverLv1(macrolotto)}
									onMouseLeave={() => setHoverLv1(null)}
									onClick={() => setLv1(macrolotto)}
									isHover={hoverLv1 && hoverLv1.id === macrolotto.id}
								>
									<td>{macrolotto.siglaMacrolotto}</td>
									<td>{macrolotto.descrizione}</td>
									<Next><i className="fas fa-chevron-right"></i></Next>
								</Tr>
							) : null}
						</tbody>
					</Table>
				</List>
			</Page>
			<Page>
				<Topbar onBack={() => setLv1(null)}>Sub-Aree</Topbar>
				<Header
					lv0={lv0 ? lv0.nome : null}
					lv1={lv1 ? lv1.siglaMacrolotto + (lv1.descrizione ? " - " + lv1.descrizione : "") : null}
				/>
				<List>
					<Table>
						<thead>
							<tr>
								<th>Nome Sub-Area</th>
								<th>Sigla Sub-Area</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{listLv2 ? listLv2.map((subarea, i) =>
								<Tr
									key={i}
									onMouseEnter={() => setHoverLv2(subarea)}
									onMouseLeave={() => setHoverLv2(null)}
									onClick={() => setLv2(subarea)}
									isHover={hoverLv2 && hoverLv2.id === subarea.id}
								>
									<td>{subarea.nome}</td>
									<td>{subarea.siglaSubarea}</td>
									<Next><i className="fas fa-chevron-right"></i></Next>
								</Tr>
							) : null}
						</tbody>
					</Table>
				</List>
			</Page>
			<SondaggiPage
				onBack={() => setLv2(null)}
				lv0={lv0} lv1={lv1} lv2={lv2}
				listLv3={listLv3}
				onMouseEnterRow={setHoverLv3}
				onMouseLeaveRow={() => setHoverLv3(null)}
				onClickRow={setLv3}
				hoverLv3={hoverLv3}
			/>

			{lv3?.tipo === 'Piezómetro'
				? <PiezometroPage
					onBack={() => setLv3(null)}
					lv0={lv0} lv1={lv1} lv2={lv2} lv3={lv3}
					listLv4={listLv4}
					hoverLv4={hoverLv4}
					onMouseEnterRow={setHoverLv4}
					onMouseLeaveRow={() => setHoverLv4(null)}
					onClickRow={setLv4}
					name={lv3.nome}
					coords={[
						...latlng(ToLL(lv3.y_utm, lv3.x_utm, 32)),
						 'N ' + lv3.y_utm, 'E ' + lv3.x_utm]}
					depth={lv3.elev_refer_msnm}
				/>

				: <CampionePage
					onBack={() => setLv3(null)}
					lv0={lv0} lv1={lv1} lv2={lv2} lv3={lv3}
					listLv4={listLv4}
					hoverLv4={hoverLv4}
					onMouseEnterRow={setHoverLv4}
					onMouseLeaveRow={() => setHoverLv4(null)}
					onClickRow={setLv4}
				/>
			}
			<Page>
				<Topbar
					onBack={() => setLv4(null)}
					downloadData={() => downloadLv4(lv4,listLv5)}
				>Dati Analitici</Topbar>
				<Header
					lv0={lv0 ? lv0.nome : null}
					lv1={lv1 ? lv1.siglaMacrolotto + (lv1.descrizione ? " - " + lv1.descrizione : "") : null}
					lv2={lv2 ? lv2.nome : null}
					lv4={lv4 ? lv4.siglaCampione : null}
					lv4color={lv4 ? colorName(lv4.coloreCampione) : null}
				/>
				{lv4 ?
					<>
						<Tabs>
							<Tab active={!showEluato} onClick={() => {setShowEluato(false)}}>Terreno</Tab>
							<Tab active={showEluato} onClick={lv4.has_eluato ? () => {setShowEluato(true)} : null} disabled={!lv4.has_eluato}>Eluato</Tab>
						</Tabs>
						<DatiList>
							{!showEluato ?
								<Table>
									<thead>
										<tr>
											<th>Parametro</th>
											<th>Valore</th>
											<th>VFN</th>
											<th>UdM</th>
										</tr>
									</thead>
									<tbody>

										{listLv5 ? listLv5.filter(dato => dato.has_terreno).map((dato, i) =>
											<React.Fragment key={i}>
												{(i === 0 || dato.descGruppo !== listLv5.filter(dato => dato.has_terreno)[i-1].descGruppo) && dato.descGruppo ?
													<Macrodivisione>
														<td colSpan="4">{dato.descGruppo}</td>
													</Macrodivisione>
												: null }
												<Tr
													key={i}
													color={colorName(dato.vfn != null
														? vfnColor(dato.colA, dato.vfn, dato.colB, dato.valore, dato.coloreDato)
														: dato.coloreDato
													)}
												>
													<td>{dato.parametro}</td>
													<td>
														{(dato.colA !== 0 && dato.colB !== 0) && (dato.colA !== "0" && dato.colB !== "0")?
															<InfoTable
																columns={dato.vfn != null ? ["Col. A", "VFN", "Col. B"] : ["Col. A", "Col. B"]}
																values={[ dato.vfn != null ? [dato.colA, dato.vfn, dato.colB] : [dato.colA, dato.colB] ]}
															/>
														: null} &nbsp;
														{variableFormat(dato.valore)}
													</td>
													<td>{dato.vfn}</td>
													<td>{dato.udm}</td>
												</Tr>
											</React.Fragment>
										) : null}

									</tbody>
								</Table>
							:
								<Table>
									<thead>
										<tr>
											<th>Parametro</th>
											<th>Valore</th>
											<th>UdM</th>
										</tr>
									</thead>
									<tbody>

										{listLv5 ? listLv5.filter(dato => dato.has_eluato).map((dato, i) =>
											<>
												{(i === 0 || dato.descGruppo !== listLv5.filter(dato => dato.has_eluato)[i-1].descGruppo) && dato.descGruppo ?
													<Macrodivisione>
														<td colSpan="4">{dato.descGruppo}</td>
													</Macrodivisione>
												: null }
												<Tr
													key={i}
													color={colorName(dato.coloreDato)}
												>
													<td>{dato.parametro}</td>
													<td>
														{dato.colA !== 0 ?
															<InfoTable
																columns={["CSC Falda"]}
																values={[[dato.colA]]}
															/>
														: null} &nbsp;
														{dato.valore}
													</td>
													<td>{dato.udm}</td>
												</Tr>
											</>
										) : null}

									</tbody>
								</Table>
							}


						</DatiList>
					</>
				: null }

			</Page>

		</Mover>
	</Wrapper>
  )
}

export default Navigator;
